import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'
import parse from 'html-react-parser'

const PortfolioCompaniesArchive = props => {
  const { partners } = props

  return (
    <div className="container">
      <div className="row">
        {partners &&
          partners?.map((partner, idx) => {
            const { url, image } = partner

            return (
              image && (
                <div className="col-6 col-lg-3 mb-2 mb-md-3" key={idx}>
                  <a
                    href={url || '#'}
                    rel="noreferrer"
                    target="_blank"
                    className="portfolio-companies-archive__logo-wrapper d-flex align-items-center justify-content-center"
                  >
                    {image && parse(image)}
                    <div className="portfolio-companies-archive__bg position-absolute top-0 start-0 w-100 h-100 z-n1">
                      <span className="portfolio-companies-archive__edge portfolio-companies-archive__edge--left position-absolute start-0"></span>
                      <span className="portfolio-companies-archive__edge portfolio-companies-archive__edge--right position-absolute end-0"></span>
                      <span className="portfolio-companies-archive__edge portfolio-companies-archive__edge--top position-absolute top-0"></span>
                      <span className="portfolio-companies-archive__edge portfolio-companies-archive__edge--bottom position-absolute bottom-0"></span>
                    </div>
                  </a>
                </div>
              )
            )
          })}
      </div>
    </div>
  )
}

PortfolioCompaniesArchive.propTypes = {
  isMobile: PropTypes.bool,
  partners: PropTypes.array,
}

export default PortfolioCompaniesArchive
